import { FILTER_TYPES } from "../components/filter/constant";
import { getAssetIcon } from "../utils/common-utils";
import { EDITOR_LABEL, OWNER_LABEL, VIEWER_LABEL } from "./roles-constants";

export const WORKSPACE_ID_KEY = "w";
export const ASSET_TYPE_KEY = "aty";
export const AGENT_ASSET_ID_KEY = "aa";
export const PARENT_ID_KEY = "pa";
export const ASSET_ID_KEY = "a";
export const PROJECT_ID_KEY = "pr";
export const SHEET_BASE_ID_KEY = "a";
export const SHEET_TABLE_ID_KEY = "t";
export const SHEET_VIEW_ID_KEY = "v";
export const EVENT_TYPE_KEY = "t";
export const QUERY_PARAM_KEY = "q";
export const SEARCH_TERM_KEY = "s";
export const SEARCH_SCOPE_KEY = "sc";
export const SEARCH_TYPE_KEY = "st";
export const SEARCH_RECURSIVE_KEY = "r";
export const SEARCH_ANNOTATION_KEY = "sa";
export const SEARCH_STATUS_KEY = "ss";
export const BATCH_KEY = "b";
export const WORKFLOW_NAME_KEY = "wfn";
export const LINKED_APP_KEY = "la";
export const AGENT_KEY = "ag";

export const FOLDER_TITLE = "Folders";
export const FORM_TITLE = "Forms";
export const WORKFLOW_TITLE = "Workflows";
export const TABLE_TITLE = "Tables";
export const CONTENT_TITLE = "Contents";
export const EMAIL_TITLE = "Emails";
export const SEQUENCE_TITLE = "Sequences";
export const AGENT_TITLE = "Agents";
export const PORTAL_TITLE = "Portals";
export const PROJECT_TITLE = "Projects";
export const FILE_TYPE = "FILE";
export const FOLDER_TYPE = "FOLDER";
export const WORKFLOW_TYPE = "WORKFLOW";

export const WORKFLOW_ANNOTATION = "WC";
export const FORM_ANNOTATION = "FC";
export const AGENT_TOOL_ANNOTATION = "TOOL";
export const INTEGRATION_ANNOTATION = "IC";
export const SHEET_ANNOTATION = "SHEET";
export const CONTENT_ANNOTATION = "CONTENT";
export const EMAIL_ANNOTATION = "EMAIL_TEMPLATE";
export const AGENT_ANNOTATION = "AGENT";
export const SEQUENCE_ANNOTATION = "SEQUENCE";
// must match the Heimdall PORTAL asset annotation registered by TinyPortal's POST /api/portals
export const PORTAL_ANNOTATION = "PORTAL";
// Campaigns live in campaign-service, not the asset store. This pseudo-annotation lets mapped
// campaign rows reuse the shared asset list/table rendering (icon, status, tint).
export const CAMPAIGN_ANNOTATION = "CAMPAIGN";
// A Project is a top-level FOLDER carrying this annotation — the outcome container that groups the
// assets (and folders) working toward one journey. Real folders nest inside it.
export const PROJECT_ANNOTATION = "PROJECT";
export const TRASH_ASSET = "TRASH_ASSET";

export const GRID_VIEW = "GRID";
export const LIST_VIEW = "LIST";
export const LOCAL_STORAGE_WORKSPACE_KEY = "lsw";

export const MY_FILES_SCOPE = "my_drive";

export const SUCCESS_TYPE = "success";
export const ERROR_TYPE = "error";
export const WARNING_TYPE = "warning";
export const INFO_TYPE = "info";

//Role Options
export const rolesOptions = [
  { id: "EDITOR", label: EDITOR_LABEL },
  { id: "OWNER", label: OWNER_LABEL },
  { id: "VIEWER", label: VIEWER_LABEL },
];

//message constants
export const RESTORE_SUCCESSFUL = "Asset restored.";
export const MOVE_ASSET_INCORRECT_FOLDER = "Please select a valid folder.";
export const RENAME_SUCCESSFUL = "Rename successfully.";
export const LINK_COPIED_SUCCESSFUL = "Link copied to clipboard.";
export const DUPLICATE_SUCCESSFUL = "Asset duplicated successfully.";
export const MOVE_SUCCESSFUL = "Asset moved successfully.";

export const EMPTY_TRASH = "All items deleted.";

//response constants
export const SUCCESS = "success";

//asset actions constants

export const DELETE_ACTION = "delete";
export const VIEW_DETAILS_ACTION = "view_details";
export const OPEN_ACTION = "open";
export const DELETE_PERMANENTLY_ACTION = "delete_permanently";
export const RESTORE_ACTION = "restore";
export const MOVE_ASSET_ACTION = "move_asset";
export const RENAME_ASSET_ACTION = "rename_asset";
export const EDIT_PROJECT_ACTION = "edit_project";
export const DUPLICATE_ASSET_ACTION = "duplicate_asset";
export const COPY_LINK_ACTION = "copy_link";
export const FORM_ANALYTICS_ACTION = "form_analytics";
export const VIEW_RESPONSES = "view_responses";
export const VIEW_EXECUTION_HISTORY = "view_execution_history";
export const FAVOURITE_ACTION = "favourite";
export const UNFAVOURITE_ACTION = "unfavourite";
export const COPY_FORM_URL_ACTION = "copy_form_url";

// Connection actions constants
export const VIEW_PERMISSIONS_ACTION = "view_permissions";

//error messages
export const INCORRECT_FILE_TYPE = "Incorrect file type";
export const FILE_SIZE_ERROR = "File size should be less than 1MB";
export const ADD_VALID_EMAIL_ID = "Please add a valid email id.";
export const USER_NOT_FOUND = "User not found.";

//sheet constants
export const USER_NAME = "name_oeqm8YnFuhqRGCKeqVfJy4";
export const TO_USER_EMAIL = "touseremail_sXrNWvL1yixjbPb1qGhSEQ";
export const REFERRAL_AMOUNT = "referralamount_bBvtW99KgcFZ8pBYvSZZvC";
export const UPDATED_DATE = "updateddatetime_sBdnZhu4o1zkBFL9UL8ER5";
export const CREATED_DATE = "createddatetime_dhugUhT8Wo6FDqVkGWSmeq";

export const SUCCESS_EXECUTION = "SUCCESS";
export const FAILED_EXECUTION = "FAILED";
export const RUNNING_EXECUTION = "RUNNING";
export const PAUSED_EXECUTION = "PAUSED";
export const ABORTED_EXECUTION = "ABORTED";

export const RECIPES_IMG_SRC =
  "https://ccc.oute.app/test/1737537905782/wcl_recipe.webp";

export const FORM_RESPONSE_ZERO_SCREEN_IMG_SRC =
  "https://ccc.oute.app/test/1736233001260/form_response.webp";

export const APP_AUTHORIZATIONS_ZERO_SCREEN_IMG_SRC =
  "https://ccc.oute.app/test/1737530449599/ConnectionsZeroScreen.svg";


export const AUTOMATION_DEMO =
  "https://ccc.oute.app/test/1740987365557/automation-demo";

export const TINY_COMMAND_FORUM_URL = "https://forum.tinycommand.com/";
export const TINY_COMMAND_YOUTUBE_URL =
  "https://www.youtube.com/embed/P9xK-8NOOcM?si=6EapwAhbsaY9Xq5w";
export const TINY_COMMAND_YOUTUBE_URL2 =
  "https://www.youtube.com/embed/YkJtvt2u6sI?si=7mVP-DohLjrM83t5";
export const SUPPORT_EMAIL = "sales@tinycommand.com";

// LTD (Lifetime Deal) Constants
export const LTD_FEATURE_FLAG = "FF_BILLING_LTD_UI";
export const LTD_QA_OVERRIDE_URL_PARAM = "forceLTD";
export const LTD_QA_OVERRIDE_STORAGE_KEY = "tc:forceLTD";
export const LTD_SUPPORT_EMAIL = "support@tinycommand.com";

// regex
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const allAssetsFilterConfig = [
  {
    type: FILTER_TYPES.SELECT,
    componentProps: {
      label: "Type",
      placeholder: "Select Type",
      options: [
        {
          iconName: getAssetIcon({
            annotation: FORM_ANNOTATION,
          }),
          label: "Forms",
          filterCriteria: {
            annotation: FORM_ANNOTATION,
            type: WORKFLOW_TYPE,
          },
        },
        {
          iconName: getAssetIcon({
            annotation: SHEET_ANNOTATION,
          }),
          label: "Table",
          filterCriteria: {
            annotation: SHEET_ANNOTATION,
            type: FILE_TYPE,
          },
        },
        {
          iconName: getAssetIcon({
            annotation: WORKFLOW_ANNOTATION,
          }),
          label: "Workflow",
          filterCriteria: {
            annotation: WORKFLOW_ANNOTATION,
            type: WORKFLOW_TYPE,
          },
        },
        {
          iconName: getAssetIcon({
            annotation: SEQUENCE_ANNOTATION,
          }),
          label: "Sequence",
          filterCriteria: {
            annotation: SEQUENCE_ANNOTATION,
            type: WORKFLOW_TYPE,
          },
        },
        {
          iconName: getAssetIcon({
            annotation: undefined,
            type: FOLDER_TYPE,
          }),
          label: "Folder",
          filterCriteria: {
            annotation: undefined,
            type: FOLDER_TYPE,
          },
        },
        {
          iconName: getAssetIcon({
            annotation: CONTENT_ANNOTATION,
          }),
          label: "Content",
          filterCriteria: {
            annotation: CONTENT_ANNOTATION,
            type: FILE_TYPE,
          },
        },

        {
          iconName: getAssetIcon({
            annotation: EMAIL_ANNOTATION,
          }),
          label: "Email",
          filterCriteria: {
            annotation: EMAIL_ANNOTATION,
            type: FILE_TYPE,
          },
        },
      ],
    },
  },
  {
    type: FILTER_TYPES.SELECT,
    componentProps: {
      label: "Status",
      placeholder: "Select Status",
      options: [
        {
          label: "Published",
          filterCriteria: {
            state: "PUBLISHED",
          },
        },
        {
          label: "Inactive",
          filterCriteria: {
            state: "Inactive",
          },
        },
        {
          label: "Active",
          filterCriteria: {
            state: "ACTIVE",
          },
        },
      ],
    },
  },
];

export const DEFAULT_SUGGESTIONS = [
  "Form for Customer Feedback Form to gather insights on product satisfaction and areas for improvement",
  "Form for Customer Feedback Form to gather insights on product satisfaction and areas for improvement",
  "Form for Customer Feedback Form to gather insights on product satisfaction and areas for improvement",
  "Form for Customer Feedback Form to gather insights on product satisfaction and areas for improvement",
];

export const SORT_OPTIONS = [
  {
    label: "Newest First",
    value: "newest",
  },
  {
    label: "Oldest First",
    value: "oldest",
  },
  {
    label: "Name A-Z",
    value: "name_a_z",
  },
  {
    label: "Name Z-A",
    value: "name_z_a",
  },
  {
    label: "Last Modified",
    value: "last_modified",
  },
];

export const PUBLISHED = "PUBLISHED";
export const DRAFT = "DRAFT";
export const TINY_COMMAND_PRICING_URL = "https://tinycommand.com/pricing";
export const TINY_COMMAND_LIFETIME_URL = "https://tinycommand.com/lifetime";
// Lifetime-deal countdown deadline (matches the /lifetime landing page). IST.
// Override per-campaign via REACT_APP_LIFETIME_DEAL_DEADLINE.
export const LIFETIME_DEAL_DEADLINE =
  process.env.REACT_APP_LIFETIME_DEAL_DEADLINE || "2026-06-17T23:59:00+05:30";

// Per-user welcome window: how many days after signup the lifetime offer stays
// buyable for that account. Override per environment with
// REACT_APP_LIFETIME_WINDOW_DAYS.
export const LIFETIME_WINDOW_DAYS = Number(
  process.env.REACT_APP_LIFETIME_WINDOW_DAYS || 3,
);

// Grandfather cutoff: accounts registered on or before this instant keep the
// deal until the campaign deadline instead of getting the short window. This
// exists so enabling the window cannot revoke the offer from every existing
// user in a single deploy. Move it back (or to an old date) to put the whole
// base on the window. Override with REACT_APP_LIFETIME_WINDOW_FROM.
export const LIFETIME_WINDOW_FROM =
  process.env.REACT_APP_LIFETIME_WINDOW_FROM || "2026-08-25T00:00:00+05:30";

// The TinyTrack lifetime Plan id to purchase in-app (the plan created manually
// in TinyTrack, with stripePriceIds.lifetime set). Data-driven via env so it's
// not hardcoded and can differ per environment (test vs prod). When unset, the
// in-app Buy gracefully falls back to the marketing page.
export const LIFETIME_PLAN_ID = process.env.REACT_APP_LIFETIME_PLAN_ID || "";

// Shown on plan/lifetime buy buttons that are disabled because the current
// workspace role (VIEWER/EDITOR) can't manage billing — only the owner can.
export const PLAN_CHANGE_ROLE_RESTRICTED_MESSAGE =
  "Only the workspace owner can change the plan.";
